import {
  ByIdPayload,
  ChangeParamsByIdPayload,
  FailByIdPayload,
  ListReducerTypes,
  NormalizedList,
  PayloadAction,
  SuccessByIdPayload,
  uniqueActionType
} from '@industi/ngx-common';
import { SymfonyPaginationParams } from '../../../symfony/list/models/symfony-pagination-params';

export const OrderItemLoadListActionTypes: ListReducerTypes = {
  request: uniqueActionType('[order/item] Load list'),
  requestFail: uniqueActionType('[order/item] Load list fail'),
  requestSuccess: uniqueActionType('[order/item] Load list success'),
  requestClear: uniqueActionType('[order/item] Load list clear'),
  changeParams: uniqueActionType('[order/item] Load list change params'),
  clearParams: uniqueActionType('[order/item] Load list clear params'),
  clearIds: uniqueActionType('[order/item] Load list clear ids')
};

export class OrderItemLoadListAction implements PayloadAction {
  readonly type = OrderItemLoadListActionTypes.request;

  constructor(public payload: ByIdPayload) {
  }
}

export class OrderItemLoadListFailAction implements PayloadAction {
  readonly type = OrderItemLoadListActionTypes.requestFail;

  constructor(public payload: FailByIdPayload) {
  }
}

export class OrderItemLoadListSuccessAction implements PayloadAction {
  readonly type = OrderItemLoadListActionTypes.requestSuccess;

  constructor(public payload: SuccessByIdPayload<NormalizedList>) {
  }
}

export class OrderItemLoadListChangeParamsAction implements PayloadAction {
  readonly type = OrderItemLoadListActionTypes.changeParams;

  constructor(public payload: ChangeParamsByIdPayload<SymfonyPaginationParams>) {
  }
}

export class OrderItemLoadListClearAction implements PayloadAction {
  readonly type = OrderItemLoadListActionTypes.requestClear;

  constructor(public payload: ByIdPayload) {
  }
}

export class OrderItemLoadListClearParamsAction implements PayloadAction {
  readonly type = OrderItemLoadListActionTypes.clearParams;

  constructor(public payload: ByIdPayload) {
  }
}

export class OrderItemLoadListClearIdsAction implements PayloadAction {
  readonly type = OrderItemLoadListActionTypes.clearIds;

  constructor(public payload: ByIdPayload) {
  }
}
